import { IconClockTable, OutlinedCalendarIcon } from '../../../../../../components/buttons/IconButtons';
import dayId from '../../../../../../hooks/dayId';
import { EMPTY_VALUES } from '../../../../../../Apis/functions';
import React from 'react';
import CustomTooltip from '../../../../../../components/CustomTooltip';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const ZoneItem = (
    {
        item
    }
) => {

    return (
        <div className="row align-items-center">

            <div className="col-sm-12 col-lg-5 col-xl-5 d-flex align-items-center mb-2 mb-xl-0 px-0">
                <div className={'flex-grow-1 minw-0 px-0'}>
                    <CustomTooltip
                        text={`${item?.zoneName || EMPTY_VALUES.DEFAULT}`}
                        classes="fs-14px ibl-font-w-600 font-color-general-950 text-ellipsis-1-row flex-grow-1"
                        showIfTruncated={true}
                        placement="top"
                    />
                </div>
            </div>

            <div className="col-sm-12 col-lg-3 col-xl-3 d-flex align-items-center mb-2 mb-xl-0 px-0">
                <div className="d-flex justify-content-center mr-2">
                    <OutlinedCalendarIcon className="icon-color-shades-600" width={16} height={16} />
                </div>
                <div className={'flex-grow-1 minw-0 px-0'}>
                    <CustomTooltip
                        text={`${ parseInt(item?.dayId ) >= 0 ? dayId(item?.dayId) : EMPTY_VALUES.DEFAULT}`}
                        classes="mb-0 fs-12px ibl-font-w-400 font-color-shades-600 text-ellipsis-1-row"
                        showIfTruncated={true}
                        placement="top"
                    />
                </div>
            </div>

            <div className="col-12 col-lg-4 col-xl-4 d-flex align-items-center mb-2 mb-xl-0 px-0">
                <div className="d-flex justify-content-center mr-2">
                    <IconClockTable className="icon-color-shades-600" width={16} height={16} />
                </div>
                <div className={'flex-grow-1 minw-0 px-0'}>
                    <CustomTooltip
                        text={`${item?.from && item?.to ? `${item?.from} - ${item?.to}` : EMPTY_VALUES.DEFAULT}`}
                        classes="mb-0 fs-12px ibl-font-w-400 font-color-shades-600 text-ellipsis-1-row"
                        showIfTruncated={true}
                        placement="top"
                    />
                </div>
            </div>
        </div>
    );

}
export default ZoneItem
